import getUSOpenVenueID from './getUSOpenVenueID';

const isUSOpenVenueId = (venueId) => venueId === getUSOpenVenueID();

const US_OPEN_VENUE_SLUG = 'the-centurion-lounge-at-us-open-tennis';

const isUSOpenVenueSlug = (venueSlug) => venueSlug === US_OPEN_VENUE_SLUG;

export {
  US_OPEN_VENUE_SLUG,
  isUSOpenVenueId,
  isUSOpenVenueSlug,
};
